var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(
                _vm.$route.name == 'swipe' ||
                    _vm.$route.name == 'swipe-slug' ||
                    _vm.$route.name == 'swipe-image' ||
                    _vm.$route.name == 'index-dev' ||
                    _vm.$route.name == 'images-dev' ||
                    _vm.$route.name == 'studio-dev' ||
                    _vm.$route.name == 'studio-image-dev' ||
                    _vm.$route.name == 'project-list-books' ||
                    _vm.$route.name == 'project-list-websites' ||
                    _vm.$route.name == 'project-list-typefaces' ||
                    _vm.$route.name == 'project-list-identities' ||
                    _vm.$route.name == 'project-detail' ||
                    _vm.$route.name == 'splash-dev'
            )?_c('NewNewMenu'):_c('NewMenu')],1),(
            _vm.$route.name == 'swipe' ||
                _vm.$route.name == 'swipe-slug' ||
                _vm.$route.name == 'swipe-image' ||
                _vm.$route.name == 'index-dev' ||
                _vm.$route.name == 'images-dev' ||
                _vm.$route.name == 'studio-dev' ||
                _vm.$route.name == 'studio-image-dev' ||
                _vm.$route.name == 'project-list-books' ||
                _vm.$route.name == 'project-list-websites' ||
                _vm.$route.name == 'project-list-typefaces' ||
                _vm.$route.name == 'project-list-identities' ||
                _vm.$route.name == 'project-detail' ||
                _vm.$route.name == 'splash-dev'
        )?_c('router-view',{staticClass:"newContainer"}):_c('keep-alive',{attrs:{"exclude":['Detail']}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }